import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let result;
    if (isLogin) {
      result = await login(email, password);
    } else {
      result = await register(email, password, name);
    }

    setLoading(false);

    if (result.success) {
      toast.success(isLogin ? 'Autentificat cu succes!' : 'Cont creat cu succes!');
      navigate('/');
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div
        className="hidden lg:flex lg:w-1/2 bg-cover bg-center relative"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1666634902071-e5a848d07180?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHR1bmElMjBmaXNoJTIwbWFya2V0fGVufDB8fHx8MTc4NTA5MzQyNnww&ixlib=rb-4.1.0&q=85')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-800/70"></div>
        <div className="relative z-10 flex flex-col justify-center items-start p-16 text-white">
          <h1 className="text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit' }}>
            TUNA FOOD BBD
          </h1>
          <p className="text-xl" style={{ fontFamily: 'IBM Plex Sans' }}>
            Alimentele tale proaspete, comenzile tale simple
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-slate-50 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none opacity-40 flex items-center justify-center">
          <img src="/logo.png" alt="" className="w-full h-full object-contain" />
        </div>

        <div className="w-full max-w-md relative z-10">
          <div className="bg-white/95 backdrop-blur-sm rounded-lg shadow-xl border border-slate-200 p-8">
            <div className="flex justify-center mb-6">
              <img src="/logo.png" alt="TUNA FOOD BBD" className="h-20 w-auto" data-testid="login-logo" />
            </div>
            <h2 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit' }}>
              {isLogin ? 'Log In' : 'Creare Cont'}
            </h2>
            <p className="text-slate-600 mb-8" style={{ fontFamily: 'IBM Plex Sans' }}>
              {isLogin ? 'Introdu datele pentru a te conecta' : 'Creează un cont nou pentru a comanda'}
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              {!isLogin && (
                <div>
                  <Label htmlFor="name" className="text-slate-700">Nume</Label>
                  <Input
                    id="name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required={!isLogin}
                    placeholder="Numele tău"
                    className="mt-1"
                    data-testid="register-name-input"
                  />
                </div>
              )}

              <div>
                <Label htmlFor="email" className="text-slate-700">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="adresa@email.com"
                  className="mt-1"
                  data-testid="login-email-input"
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-slate-700">Parolă</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                  className="mt-1"
                  data-testid="login-password-input"
                />
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-blue-900 hover:bg-blue-800 text-white transition-all"
                data-testid="login-submit-button"
                style={{ fontFamily: 'IBM Plex Sans' }}
              >
                {loading ? 'Se procesează...' : isLogin ? 'Conectare' : 'Creare Cont'}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <button
                onClick={() => setIsLogin(!isLogin)}
                className="text-blue-900 hover:text-blue-700 font-medium transition-colors"
                data-testid="toggle-auth-mode-button"
                style={{ fontFamily: 'IBM Plex Sans' }}
              >
                {isLogin ? 'Nu ai cont? Creează unul' : 'Ai deja cont? Conectează-te'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;